import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

// Actions
import { logout } from 'src/store/auth/actions';

// Components
import Modal from './ModalLogout';

class LogoutBtnWithModal extends Component {
  constructor() {
    super();
    this.state = {
      logoutModalIsOpen: false
    };
    this.logout = this.logout.bind(this);
    this.triggerModal = this.triggerModal.bind(this);
  }

  triggerModal() {
    this.setState({ logoutModalIsOpen: !this.state.logoutModalIsOpen });
  }

  logout() {
    const { auth, logout } = this.props;
    this.triggerModal();
    logout(auth);
  }

  render() {
    const { wrapperClassName, btnClassName, btnLabel, i18n } = this.props;
    return (
      <div className={wrapperClassName}>
        <button className={btnClassName} onClick={this.triggerModal}>
          {btnLabel || i18n.t('log_out')}
        </button>
        {/* ──── Logout modal ──────────────────────────────────────────────────────────────── */}
        <Modal
          isOpen={this.state.logoutModalIsOpen}
          logout={this.logout}
          closeModal={this.triggerModal}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});

export default translate()(
  connect(
    mapStateToProps,
    { logout }
  )(LogoutBtnWithModal)
);
